import { createClient } from '@supabase/supabase-js';

// Чистим значение переменной окружения: убираем пробелы/переносы и случайные
// кавычки по краям (частая ошибка при вставке значения в настройках Vercel),
// и дописываем https:// если префикс потерян. Иначе createClient падает с
// «Invalid supabaseUrl» ещё до старта React и весь экран становится серым.
function cleanEnv(v) {
  return String(v || '').trim().replace(/^['"]+|['"]+$/g, '');
}
let SUPABASE_URL = cleanEnv(process.env.REACT_APP_SUPABASE_URL);
const SUPABASE_KEY = cleanEnv(process.env.REACT_APP_SUPABASE_ANON_KEY);
if (SUPABASE_URL && !/^https?:\/\//i.test(SUPABASE_URL)) SUPABASE_URL = 'https://' + SUPABASE_URL;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  // Понятное сообщение вместо белого экрана без объяснений.
  const msg = 'Не заданы переменные окружения Supabase (REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY). Проверьте настройки проекта на Vercel и пересоберите деплой.';
  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
      const root = document.getElementById('root');
      if (root) root.innerHTML = '<div style="max-width:520px;margin:80px auto;font-family:system-ui,sans-serif;padding:24px;border:1px solid #eee;border-radius:12px;color:#333;line-height:1.5"><h3 style="margin-top:0">Ошибка конфигурации</h3><p>' + msg + '</p></div>';
    });
  }
  throw new Error(msg);
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

// ── ВХОД БЕЗ ПАРОЛЯ — по коду/логину ────────────────────────────────────────

export async function loginUser(code) {
  const login = code.trim().toLowerCase();

  const { data: user, error } = await supabase
    .from('users')
    .select('*')
    .eq('login', login)
    .eq('is_active', true)
    .single();

  if (error || !user) throw new Error('Код не найден. Проверьте правильность ввода.');

  localStorage.setItem('tabel_user', JSON.stringify(user));
  touchLastSeen(user.id);
  return user;
}

// Отметка «последний вход» (для алёрта «СВ не заходит»). Ошибки игнорируем:
// отметка не должна ломать вход, даже если поле ещё не создано в БД.
export function touchLastSeen(userId) {
  if (!userId) return;
  try {
    supabase.from('users').update({ last_seen_at: new Date().toISOString() }).eq('id', userId).then(() => {}, () => {});
  } catch (e) { /* ignore */ }
}

export function getCurrentUser() {
  const raw = localStorage.getItem('tabel_user');
  return raw ? JSON.parse(raw) : null;
}

export function logoutUser() {
  localStorage.removeItem('tabel_user');
}

export async function createUser({ login, full_name, role = 'sv', tm_id = null }) {
  const { data, error } = await supabase
    .from('users')
    .insert({
      login: login.trim().toLowerCase(),
      full_name,
      role,
      tm_id,
      is_active: true,
    })
    .select()
    .single();

  if (error) throw new Error(error.message);
  return data;
}

// Создать первого admin (страница /setup)
export async function createAdminUser({ login, full_name }) {
  const { data, error } = await supabase
    .from('users')
    .insert({ login: login.trim().toLowerCase(), full_name, role: 'admin', is_active: true })
    .select()
    .single();
  if (error) throw new Error(error.message);
  return data;
}

// ── ЗАМЕНА / УВОЛЬНЕНИЕ СВ (делает ТМ своим СВ, админ любым) ─────────────────
// action: 'replace' (новый СВ на то же место, нужен newName) | 'dismiss' (уволить, маршруты остаются без СВ)
// Возвращает { login, full_name, action }; login — новый логин (только при replace), показывается один раз.
export async function changeSv({ svId, action, newName = '', actorId }) {
  const { data, error } = await supabase.rpc('change_sv', {
    p_sv_id: svId, p_action: action, p_new_name: newName, p_actor: actorId,
  });
  if (error) throw new Error(error.message);
  return data;
}

// Логин СВ (для показа ТМ)
export async function getUserLogin(userId) {
  if (!userId) return null;
  const { data } = await supabase.from('users').select('login, is_active, last_seen_at').eq('id', userId).maybeSingle();
  return data || null;
}
